module.exports = __webpack_public_path__ + "img/hash查交易.e2703c39.jpg";